module.exports = __webpack_public_path__ + "img/clip.9dbb2e5.svg";